import {
  generic_get_network_request,
  generic_post_network_request,
  generic_delete_network_request,
} from '../axiosClient/axiosClient';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface Form_Info_Type {
  form_id: number; 
  form_name: string;
  s3_path: string;
  uploaded_by: number;
  created_at: string;
  is_active: number;
}

export interface GetFormsByCompany_Response_Type {
  data: Form_Info_Type[];
}

export interface UploadForm_Response_Type {
  data: {
    form_id: number;
    s3_path: string;
    company_id: number;
    created_at: string;
  }[];
}

export interface DeleteForm_Response_Type {
  success: boolean;
}

// ─── API Functions ────────────────────────────────────────────────────────────

export const getFormsByCompany = (api_endpoint: string) =>
  generic_get_network_request<GetFormsByCompany_Response_Type>(api_endpoint);

export const uploadForm = (formData: FormData) =>
  generic_post_network_request<UploadForm_Response_Type, FormData>(
    'forms/upload',
    formData,
    true
  );

export const deleteForm = (form_id: number) =>
  generic_delete_network_request<DeleteForm_Response_Type>(`forms/${form_id}`);
